
const initialState = () => ({
    profile_form: {
        ID:"",
        TYPE: "",
        NAME: "",
        ADDRESS: "",
        EMAIL: "",
        TAX_ID: "",
        BRANCH: "",
        TEL: "",
        MOBILE_TEL: "",
        FAX: "",
        SIGNATURE:"",
        WEBSITE: "",
    },

});

const state = initialState()


const getters = {
    GET_COMP_PROFILE: state => state.profile_form,

}

const mutations = {
    SET_ALL_ELEMENT(state, data) {
        state.profile_form = Object.assign({}, data);
    },
    MERGE_ALL_ELEMENT(state, data) {
        let object1 = state.profile_form
        state.profile_form = Object.assign(object1, data);
    },
    SET_ELEMENT(state, data) {
        state.profile_form[data.key] = data.value;
    },
    RESET(state) {
        const newState = initialState();
        Object.keys(newState).forEach(key => {
            state[key] = newState[key]
        });
    },

}

const actions = {
    reset({ commit }) {
        commit('RESET');
    }
}
// Mutations

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}